import React, { ReactNode, useState } from "react";
import * as S from "./styles.ts";
import { H6, P } from "@template/components";
import { ChevronDown } from "@template/icons";

export interface ITextDropdownProps {
  title: string;
  children: ReactNode;
  expandedDefault?: boolean;
  fullWidth?: boolean;
  smallText?: boolean;
}

const TextDropdown = ({
                        title,
                        children,
                        expandedDefault = false,
                        fullWidth = false,
                        smallText = false,
                      }: ITextDropdownProps) => {
  const [expanded, setExpanded] = useState<boolean>(expandedDefault);

  return (
    <S.DropdownContainer>
      <S.DropdownTitle
        $fullWidth={fullWidth}
        onClick={() => setExpanded(!expanded)}
      >
        {smallText ? <P $small>{title}</P> : <H6>{title}</H6>}
        <S.ExpandArrowContainer $expanded={expanded}>
          <ChevronDown />
        </S.ExpandArrowContainer>
      </S.DropdownTitle>
      <S.DropdownContent $expanded={expanded}>{children}</S.DropdownContent>
    </S.DropdownContainer>
  );
};

export default TextDropdown;
